import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

// ✅ Assuming you already have plantColumnCatalog
// { fieldName: { headerName: "...", ... } }

const ColumnSelector = ({ visibleColumns, setVisibleColumns, plantColumnCatalog }) => {
    const [modalOpen, setModalOpen] = useState(false);

    const toggleModal = () => setModalOpen(!modalOpen);

    const handleCheckboxChange = (field) => {
        if (visibleColumns.includes(field)) {
            setVisibleColumns(visibleColumns.filter((c) => c !== field));
        } else {
            setVisibleColumns([...visibleColumns, field]);
        }
    };

    return (
        <>
            <button
                type="button"
                onClick={toggleModal}
                className="btn btn-sm"
                style={{ backgroundColor: "#fff", borderColor: "#d1d5db", color: "#212529" }}
            >
                Columns
            </button>

            <Modal isOpen={modalOpen} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>Choose Columns</ModalHeader>
                <ModalBody>
                    {Object.keys(plantColumnCatalog).map((field) => (
                        <div key={field} className="form-check">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id={`col-${field}`}
                                checked={visibleColumns.includes(field)}
                                onChange={() => handleCheckboxChange(field)}
                            />
                            <label className="form-check-label" htmlFor={`col-${field}`}>
                                {plantColumnCatalog[field].headerName}
                            </label>
                        </div>
                    ))}
                </ModalBody>
                <ModalFooter>
                    <button className="btn" style={{ backgroundColor: "#fff", borderColor: "#d1d5db", color: "#374151" }} onClick={toggleModal}>
                        Done
                    </button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default ColumnSelector;
